import { Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { InviteUserButton } from '../interaction/InviteUserButton';

interface UsersEmptyStateProps {
  onInviteSuccess?: () => void;
}

export function UsersEmptyState({ onInviteSuccess }: UsersEmptyStateProps) {
  const { t } = useTranslation('usersModule');

  return (
    <div
      className="rounded-lg border border-dashed border-border bg-muted/20 px-6 py-10 sm:px-8"
      data-testid="users-empty-state"
    >
      <div className="mx-auto flex max-w-sm flex-col items-center text-center">
        <div className="flex h-10 w-10 items-center justify-center rounded-full border border-border bg-background">
          <Users className="h-5 w-5 text-muted-foreground" aria-hidden />
        </div>

        <h3 className="mt-3 text-base font-semibold text-foreground">{t('emptyState.title')}</h3>
        <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{t('emptyState.description')}</p>

        <div className="mt-5">
          <InviteUserButton onSuccess={onInviteSuccess} />
        </div>
      </div>
    </div>
  );
}
